type ClassValue = string | undefined | null | false

export const joinClassNames = (...classes: ClassValue[]): string =>
  classes.filter(Boolean).join(' ')
